import Marquee from "react-fast-marquee";
import { Diamond } from "@phosphor-icons/react";
import { MARQUEE_ITEMS } from "../data/site";

export const MarqueeStrip = ({ dark = false }) => (
  <div
    data-testid="marquee-strip"
    className={`overflow-hidden border-y py-5 ${dark ? "border-white/10 bg-foreground" : "border-border bg-background"}`}
  >
    <Marquee speed={28} gradient={false} pauseOnHover>
      {MARQUEE_ITEMS.map((item) => (
        <span key={item} className="mx-8 flex items-center gap-8">
          <span className={`font-display text-2xl font-light italic tracking-wide ${dark ? "text-background/90" : "text-foreground/80"}`}>
            {item}
          </span>
          <Diamond size={9} weight="fill" className="text-primary" />
        </span>
      ))}
    </Marquee>
  </div>
);
